import React, { createContext, useState, useEffect, ReactNode } from "react";

type RubyVisibleStateContextType = {
  visible: boolean;
  toggleVisible: () => void;
}

const defaultState: RubyVisibleStateContextType = {
  visible: true,
  toggleVisible: () => { },
}

export const RubyVisibleStateContext = createContext<RubyVisibleStateContextType>(defaultState);

export const RubyVisibleStateProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

  const [visible, setVisible] = useState<boolean>(defaultState.visible);

  const toggleVisible = () => {
    localStorage.setItem("visible", JSON.stringify(!visible))
    setVisible(!visible)
  }

  useEffect(() => {
    const visible = JSON.parse(localStorage.getItem("visible") || JSON.stringify(defaultState.visible));
    setVisible(!!visible);
  }, [])

  return (
    <RubyVisibleStateContext.Provider
      value={{ visible, toggleVisible }}
    >
      {children}
    </RubyVisibleStateContext.Provider>
  )
}

export default RubyVisibleStateContext